import { render, staticRenderFns } from "./Confirmed.vue?vue&type=template&id=76b04d64"
import script from "./Confirmed.vue?vue&type=script&lang=js"
export * from "./Confirmed.vue?vue&type=script&lang=js"
import style0 from "./Confirmed.vue?vue&type=style&index=0&id=76b04d64&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports